import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  root: {
    objectFit: 'contain',
    transition: '0.4s',
  },
});
